<template>
    <div class="task-type">
        <headers title='选择作业类型'
                 :is_finish='is_finish'></headers>
        <div class="content">
            <div class="d_title">
                <span class="h2">{{ typeLists[sid].title }}</span>
            </div>
            <div class="d_con"
                 v-for="(item,index) in typeLists[sid].list"
                 :key="index"
                 @click='goDetail(item)'>
                <div>
                    <img :src="item.icon"
                         alt=""
                         :style="item.style">
                </div>
                <div class="d_center">
                    <p class="h3">{{ item.title }}</p>
                    <p>{{ item.desc }}</p>
                </div>
                <div>
                    <em></em>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue'
export default {
    data () {
        return {
            is_finish: localStorage.getItem('subjectLength') <= 1,//从本地读取教师带的科目数并判断
            type: this.$route.query.type,
            sid: this.$route.params.subject || "11",
            dept_type: this.$route.query.dept_type || '0',
            typeLists: {
                "11": {
                    title: "爱尚书法",
                    list: [
                        {
                            id: 1,
                            title: "书法同步练习",
                            desc: "与教材课程同步",
                            icon: require("./img/calligraphy01.png"),
                            style: {
                                width: "1.5rem",
                                height: "1.275rem"
                            }
                        },
                        {
                            id: 2,
                            title: "书法作品展示",
                            desc: "上传并展示书法作品",
                            icon: require("./img/calligraphy03.png"),
                            style: {
                                width: "1.4rem",
                                height: "1.45rem"
                            }
                        },
                    ]
                },
                "12": {
                    title: "爱尚编程",
                    list: [
                        {
                            id: 11,
                            title: "初级课程",
                            desc: "学习编程基础",
                            icon: require("./img/programming01.png"),
                            style: {
                                width: "1.35rem",
                                height: "1.25rem"
                            }
                        },
                        {
                            id: 12,
                            title: "中级课程",
                            desc: "进一步了解编程",
                            icon: require("./img/programming02.png"),
                            style: {
                                width: "1.4rem",
                                height: "1.425rem"
                            }
                        },
                        {
                            id: 13,
                            title: "高级课程",
                            desc: "深入学习编程",
                            icon: require("./img/programming03.png"),
                            style: {
                                width: "1.35rem",
                                height: "1.3rem"
                            }
                        },
                    ]
                },
                "13": {
                    title: "爱尚模型",
                    list: [
                        {
                            id: 21,
                            title: "建筑模型",
                            desc: "体验建筑之美",
                            icon: require("./img/model01.png"),
                            style: {
                                width: "1.575rem",
                                height: "1.55rem"
                            }
                        },
                        {
                            id: 22,
                            title: "桥梁模型",
                            desc: "了解桥梁结构",
                            icon: require("./img/model02.png"),
                            style: {
                                width: "1.675rem",
                                height: "1.15rem"
                            }
                        },
                        {
                            id: 23,
                            title: "航天模型",
                            desc: "了解飞行原理",
                            icon: require("./img/model03.png"),
                            style: {
                                width: "1.425rem",
                                height: "1.425rem"
                            }
                        },
                        {
                            id: 24,
                            title: "车辆模型",
                            desc: "了解运动原理",
                            icon: require("./img/model04.png"),
                            style: {
                                width: "1.55rem",
                                height: "1.45rem"
                            }
                        },
                    ]
                }
            }
        }
    },
    methods: {
        goDetail (item) {

            let url = "";
            if (this.sid == '11' && item.id == 1) {
                url = '/qualityStation/tea/select_chapter'
            } else if (this.sid == '11' && item.id == 2) {
                if (this.dept_type) {
                    url = '/qualityStation/require?dept_type=2'
                } else {
                    url = '/qualityStation/require'
                }

            }
            else {
                url = `/qualityStation/select_video/${this.sid}/${item.id}?title=${encodeURIComponent(item.title)}`
            }
            this.$router.push(url)
        }
    },
    components: {
        headers
    },
    created () {
        localStorage.removeItem('chinese_send_ok');

    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.h2 {
    font-size: 30px / $ppr;
    font-weight: bold;
}

.h3 {
    font-weight: bold;
}

.task-type {
    min-height: 100vh;
    .header {
        background: #5e89ef;
        .left {
            display: block;
            width: 18px / $ppr;
            height: 34px / $ppr;
            background: url("./img/choose_back.png") 0 0 no-repeat;
            background-size: 100% 100%;
        }
    }
}

.content {
    padding-bottom: 20px / $ppr;
    .d_title {
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        border-bottom: 1px / $ppr solid #e8e8e8;
        padding-left: 24px / $ppr;
        background: #fff;
        span {
            padding-left: 16px / $ppr;
            border-left: 4px / $ppr solid #5e89ef;
        }
    }
    .d_con {
        height: 150px / $ppr;
        background: #fff;
        padding: 0 30px / $ppr;
        display: flex;
        display: -webkit-flex;
        position: relative;
        border-bottom: 1px / $ppr solid #e8e8e8;
        &:last-child {
            border-bottom: none;
        }
        div {
            height: 100%;
            display: inline-block;
        }

        .qimo_paper {
            width: 136px / $ppr;
            height: 36px / $ppr;
            position: absolute;
            top: 29px / $ppr;
            left: 225px / $ppr;
        }

        div:nth-of-type(1) {
            display: flex;
            width: 67px / $ppr;
            display: -webkit-flex;
            justify-content: center;
            -webkit-justify-content: center;
            align-items: center;
            -webkit-align-items: center;
        }
        .d_center {
            padding-left: 20px / $ppr;
            p {
                height: 75px / $ppr;
                line-height: 100px / $ppr;
                text-align: left;
            }
            p:nth-of-type(2) {
                color: gray;
                line-height: 50px / $ppr;
                font-size: 24px / $ppr;
            }
        }
        div:nth-of-type(3) {
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            -webkit-justify-content: center;
            align-items: center;
            -webkit-align-items: center;
            -webkit-box-align: center;
            position: absolute;
            right: 0;
            em {
                display: inline-block;
                width: 30px / $ppr;
                height: 30px / $ppr;
                background: url("./img/icon_next.png");
                background-repeat: no-repeat;
                background-size: contain;
            }
        }
    }
}
</style>
